import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAppDispatch } from '@core/hooks/appHooks';
import {
  RoutingPaths,
  RoutingViews,
  getViewFromPath,
} from '@core/services/routingService';
import { navigateTransitioned } from '@helpers/app.helper';
import { useAuth } from '@providers/authProvider';

const Toolbar: React.FC = () => {
  const CSSBlock = 'toolbar';
  const location = useLocation();
  const { logOut } = useAuth();
  const view = getViewFromPath(location.pathname, false);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const onClick = (view: RoutingViews) =>
    navigateTransitioned({
      dispatch,
      navigate,
      to: RoutingPaths[view],
    });

  const routes = [
    { view: RoutingViews.HOME, icon: 'fa-house', label: 'Dashboard' },
    { view: RoutingViews.CLIENTS, icon: 'fa-users', label: 'Clients' },
    {
      view: RoutingViews.INVENTORY,
      icon: 'fa-jet-fighter',
      label: 'Inventory',
    },
    {
      view: RoutingViews.TRANSACTIONS,
      icon: 'fa-money-bill',
      label: 'Transactions',
    },
  ];

  const navButtons = routes.map(route => (
    <button
      className={`${CSSBlock}__item ${
        view === route.view ? `${CSSBlock}__item--active` : ''
      }`}
      onClick={() => onClick(route.view)}>
      <span className={`${CSSBlock}__item-icon`}>
        <i className={`fa-regular ${route.icon}`} />
      </span>
      <div className={`${CSSBlock}__item-text`}>{route.label}</div>
    </button>
  ));

  return (
    <div className={`${CSSBlock}__wrapper`}>
      <div className={`${CSSBlock}`}>
        {navButtons}
        <div className={`${CSSBlock}__separator`} />
        <button
          className={`${CSSBlock}__item ${CSSBlock}__item--logout`}
          onClick={() => logOut()}>
          <span className={`${CSSBlock}__item-icon`}>
            <i className={'fa-solid fa-arrow-right-from-bracket'} />
          </span>
        </button>
      </div>
    </div>
  );
};

export default Toolbar;
